import React from 'react';
import Chip from '@material-ui/core/Chip';

import { IContextOption } from './context-selector.types';

type GetTagProps = ({ index }: { index: number }) => {};

// Shared renderTags for the multi-select rows: chips whose key is in
// `flaggedKeys` get the danger styling + a hover title explaining the flag.
export const renderFlaggedTags = (flaggedKeys: Set<string>, flagTitle: string) =>
  (tagValue: IContextOption[], getTagProps: GetTagProps) =>
    tagValue.map((option, index) => {
      const tagProps = getTagProps({ index }) as { className?: string };
      const flagged = flaggedKeys.has(option.key);
      return (
        <Chip
          key={option.key}
          {...tagProps}
          size="small"
          label={option.label}
          className={flagged ? `${tagProps.className || ''} context-chip-misfit` : tagProps.className}
          title={flagged ? flagTitle : undefined}
        />
      );
    });
